import { Injectable } from '@angular/core';
import { AuthStatePersistenceService, createFrom, EventService } from '@spartacus/core';
import { NavigationEvent } from '@spartacus/storefront';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { Ga4GgCheckoutReviewPageEvent } from './ga4-gg-checkout-review-page-event';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { Cart } from '@spartacus/cart/base/root';

@Injectable({
  providedIn: 'root',
})
export class Ga4GgCheckoutReviewPageEventBuilder {
  constructor(
    private eventService: EventService,
    private activeCartService: ActiveCartService,
    private authStatePersistenceService: AuthStatePersistenceService
  ) {
    const ga4GgCheckoutReviewOrderPageEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'checkoutReviewOrder'),
      switchMap(() =>
        this.activeCartService.getActive().pipe(
          filter((activeCart) => Boolean(activeCart.entries)),
          take(1),
          map((activeCart) =>
            createFrom(Ga4GgCheckoutReviewPageEvent, {
              event: 'checkout_review',
              visitor_type: authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
              ecommerce: {
                currency: activeCart.totalPrice?.currencyIso,
                coupon: this.getAppliedVouchersFromCart(activeCart),
                value: activeCart.totalPrice?.value,
                items: this.getItemsFromCart(activeCart),
              },
            })
          )
        )
      )
    );

    eventService.register(Ga4GgCheckoutReviewPageEvent, ga4GgCheckoutReviewOrderPageEventSource);
  }

  private getItemsFromCart(cart) {
    const items: {
      item_id?: string;
      item_name?: string;
      discount?: string;
      coupon?: string;
      price?: number;
      quantity?: number;
    }[] = [];

    cart?.entries?.forEach((entry) => {
      const item = {
        item_id: entry.product.code,
        item_name: entry.product.modelMark,
        discount:
          entry.totalPriceOnePiece && entry.basePrice?.value && entry.totalPriceOnePiece < entry.basePrice?.value
            ? (entry.basePrice?.value - entry.totalPriceOnePiece).toFixed(2)
            : undefined,
        coupon: this.getAppliedVouchersFromCart(cart),
        price: entry.basePrice.value,
        quantity: entry.quantity,
      };

      entry.product.categoryHierarchy?.forEach((category, index) => {
        item['item_category' + (index.toString() !== '0' ? (index + 1).toString() : '')] = category.name;
      });

      Object.keys(item).forEach((key) => (item[key] === undefined ? delete item[key] : {}));

      items.push(item);
    });

    return items;
  }

  getAppliedVouchersFromCart(cart: Cart) {
    let appliedVouchers: string | undefined = undefined;

    cart.appliedVouchers?.forEach((voucher) => {
      appliedVouchers = appliedVouchers ? appliedVouchers + ',' + voucher.code : voucher.code;
    });

    return appliedVouchers;
  }
}
